export const defaultColumns = [
  { label: 'Ações', value: 'actions', className: 'w-9' },
  { label: 'Status', value: 'status', className: 'w-9' },
  { label: 'Nome', value: 'name' },
  { label: 'Produto', value: 'product_name' },
]
